<h2 mat-dialog-title>{{'commonconfirmDialog.confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{firstMessage}}<br>
    {{secondMessage}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <div *ngIf="cancellable">
      <button mat-button color="primary" [mat-dialog-close]="false">{{'commonconfirmDialog.cancel' | translate}}</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">{{'commonconfirmDialog.save' | translate}}</button>
    </div>
    <div *ngIf="!cancellable">
      <button mat-raised-button color="primary" [mat-dialog-close]="'yes'">{{'commonconfirmDialog.ok' | translate}}</button>
    </div>
  </mat-dialog-actions>
</div>